import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIExternalizingBehavior',
    label: 'SSBIExternalizingBehavior',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
